import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/layer/update/layer.update.mutation.gql"
import type {
  LayerUpdateMutation,
  LayerUpdateMutationVariables,
} from "@/v2-backoffice-client/layer/update/__types__/layer.update.mutation"

type Options = MutationHookOptions<
  LayerUpdateMutation,
  LayerUpdateMutationVariables
>

export function useLayerUpdateMutation(options?: Options) {
  return useMutation<LayerUpdateMutation, LayerUpdateMutationVariables>(
    mutation,
    options,
  )
}
